<div class="auth-split" (keydown)="onKeydown($event)">
  <!-- Left brand panel (hidden on small screens) -->
  <aside class="brand-panel">
    <div class="brand-panel-inner">
      <div class="brand-badge-wrapper">
        <span class="brand-pill">✨ SEÑALIZACIÓN DIGITAL INTELIGENTE</span>
      </div>

      <h1 class="brand-panel-title">Controlá la cartelería de todas tus sucursales</h1>
      <p class="brand-panel-sub">Publicá promociones, menús dinámicos y comunicados en tiempo real desde un solo panel centralizado.</p>

      <ul class="brand-panel-benefits">
        <li>
          <div class="benefit-icon-wrap">
            <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
          </div>
          <div>
            <strong>Control total en la nube</strong>
            <span>Actualizá precios y contenido en segundos</span>
          </div>
        </li>
        <li>
          <div class="benefit-icon-wrap">
            <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
          </div>
          <div>
            <strong>Multi-pantallas simultáneas</strong>
            <span>Agrupá pantallas por sucursal o sector</span>
          </div>
        </li>
        <li>
          <div class="benefit-icon-wrap">
            <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
          </div>
          <div>
            <strong>Confiabilidad continua</strong>
            <span>Reproducción offline garantizada ante cortes</span>
          </div>
        </li>
      </ul>

      <!-- Interactive CSS Player Showcase Mockup -->
      <div class="player-mockup">
        <div class="player-topbar">
          <div class="player-controls">
            <span class="ctrl-dot red"></span>
            <span class="ctrl-dot yellow"></span>
            <span class="ctrl-dot green"></span>
          </div>
          <div class="player-title">Pantalla 1 · Salón Principal</div>
          <div class="player-live-badge">
            <span class="live-pulse"></span>
            <span>EN VIVO</span>
          </div>
        </div>

        <div class="player-screen">
          <div class="screen-content">
            <div class="screen-hero">
              <span class="screen-tag">MENÚ DEL DÍA</span>
              <h3 class="screen-heading">Combo Gourmet Especial</h3>
              <p class="screen-desc">Hamburguesa Angus + Papas Rústicas + Bebida</p>
              <div class="screen-price-tag">
                <span class="price-curr">$</span><span class="price-val">12.500</span>
              </div>
            </div>
            <div class="screen-badge-overlay">
              <span class="badge-icon">⏱</span>
              <span>Rotación cada 15s</span>
            </div>
          </div>
          <div class="screen-playlist-bar">
            <div class="playlist-item active">Promo Almuerzo</div>
            <div class="playlist-item">Video Institucional</div>
            <div class="playlist-item">Postres & Café</div>
          </div>
        </div>
      </div>

      <div class="brand-trust-footer">
        <div class="trust-stars">★★★★★</div>
        <p class="trust-text">Más de 500 empresas ya impulsan sus ventas con Captar Media</p>
      </div>
    </div>
  </aside>

  <!-- Right interaction panel -->
  <main class="form-panel">
    <div class="form-panel-body">
      <div class="form-panel-content">
        <!-- Brand logo -->
        <div class="form-header-wrap">
          <img *ngIf="!isNoesys" class="form-panel-logo" src="assets/img/captarmedia-login.png" alt="Captar Media">
          <img *ngIf="isNoesys" class="form-panel-logo" src="assets/img/noesys-login.png" alt="Noesys">
        </div>

        <div class="view-header">
          <h2 class="view-title">Iniciar sesión</h2>
          <p class="view-subtitle">Ingresá a tu panel para gestionar tus pantallas</p>
        </div>

        <!-- Alert messages -->
        <div *ngIf="successMessage" class="mb-3">
          <ngb-alert [type]="alertType" (close)="successMessage = null">
            <strong>{{ successMessage }}</strong>
          </ngb-alert>
        </div>

        <div class="form-login">
          <div class="form-group">
            <label for="loginUsername">Usuario o Correo electrónico</label>
            <div class="input-wrap">
              <span class="input-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
              </span>
              <input id="loginUsername" [(ngModel)]="username" type="text" class="form-control" placeholder="tu@empresa.com o usuario">
            </div>
          </div>

          <div class="form-group">
            <label for="loginPassword">Contraseña</label>
            <div class="input-wrap password-wrap">
              <span class="input-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
              </span>
              <input id="loginPassword" [(ngModel)]="password" [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="Ingresá tu contraseña">
              <button type="button" class="password-toggle" (click)="togglePassword()" [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <svg *ngIf="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                </svg>
                <svg *ngIf="showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Options row: Remember me & Forgot password -->
          <div class="login-options-row">
            <label class="remember-option">
              <input [(ngModel)]="remenber" class="remember-checkbox" type="checkbox">
              <span class="remember-label-text">Recordar sesión</span>
            </label>
            <a routerLink="/recuperar" class="forgot-link">¿Olvidaste tu contraseña?</a>
          </div>

          <button type="button" class="btn-cta" (click)="login()">
            Ingresar al Panel
          </button>

          <!-- Resend activation box if needed (temporarily hidden)
          <div *ngIf="showResend" class="resend-box mt-3">
            <p class="resend-text">¿No recibiste el correo de activación?</p>
            <button type="button" class="btn btn-outline-primary btn-sm w-100" (click)="resendActivation()" [disabled]="resendLoading">
              {{ resendLoading ? 'Enviando correo...' : 'Reenviar enlace de activación' }}
            </button>
            <div *ngIf="resendSuccess" class="resend-success-text mt-2">¡Correo de activación reenviado con éxito!</div>
          </div>
          -->

          <p class="form-switch">
            ¿No tenés una cuenta aún?
            <a routerLink="/registro" class="form-switch-link">Creá tu cuenta gratis</a>
          </p>
        </div>
      </div>
    </div>

    <footer class="form-panel-footer">
      <small class="footer-text">Captar Media · Plataforma de Señalización Digital</small>
    </footer>
  </main>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/login/login.component.html